import React from 'react';
import { TextField, InputAdornment, Icon, IconButton } from '@material-ui/core';

interface IFilterChipsSearchField {
    searchText: string,
    setSearchText: (text: string) => void,
    error?: boolean,
    errorText?: string,
}

export function FilterChipsSearchField({ searchText, setSearchText, error, errorText }: IFilterChipsSearchField) {

    const getEndAdorment = () => {
        if (searchText.length > 0) {
            return (
                <InputAdornment position="end">
                    <IconButton onClick={ () => setSearchText('') }>
                        <Icon className={'material-icons-round'}>close</Icon>
                    </IconButton>
                </InputAdornment>
            );
        }
    };

    return (
        <TextField
            fullWidth
            placeholder="Pesquisar"
            value={ searchText }
            onChange={ (event: React.ChangeEvent<HTMLInputElement>) => setSearchText(event.target.value) }
            error={ error }
            helperText={ error && errorText ? errorText : ''}
            style={{ marginBottom: '4px' }}
            InputProps={{
                startAdornment:
                    <InputAdornment position="start">
                        <Icon className={'material-icons-round'}>search</Icon>
                    </InputAdornment>,
                endAdornment: getEndAdorment()
            }}
        />
    );
}